import React from "react";

const Error404page = () => {
	return <p>404 Error - Nothing here...</p>;
};

export default Error404page;
